import { selectNodeParent } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

const usePages = () =>
  useSelector((state: AppState) => {
    return state.manager.project.nodes.reduce(
      (acc, node) => {
        const parentId = selectNodeParent(node.id)(state)[0]

        acc[node.id] = {
          id: node.id,
          title: node.title,
          colorId: node.colorId,
          parentId,
          collapsed: node.collapsed,
          notes: node.notes,
        }
        return acc
      },
      {} as Record<string, any>
    )
  })

export default usePages
